<template>
  <div>
    <v-layout class="mt-5 mb-2">
      <v-flex xs4 sm3 lg2 class="mr-3 ">
        <v-select
          v-model="buscarSelect"
          :items="buscaOptions"
          label="Tipo de busca"
          outlined
          menu-props="offsetY"
          :disabled="isFormLoading || (acao == 'novo' || acao == 'editar')"
          :background-color="isFormLoading || (acao == 'novo' || acao == 'editar') ? '#f2f2f2' : null"
          @change="onChangeBuscaOptions"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm9 lg6>
        <v-autocomplete
          v-model="searchSelected"
          :items="buscaPreparacoes"
          item-value="identificadorpreparacao"
          item-text="descricaopreparacao"
          :hide-no-data="!search && buscaPreparacoes.length == 0 && !buscarLoading"
          :no-data-text="buscarLoading ? 'Carregando dados, aguarde...' : `Nenhuma opção encontrada com '${search}'`"
          outlined
          label="Buscar por"
          placeholder="Digite um valor para buscar"
          prepend-inner-icon="search"
          :search-input.sync="search"
          :filter="filtrarBusca"
          @keydown="buscar()"
          :loading="buscarLoading"
          @change="encontrado"
          :disabled="isFormLoading || (acao == 'novo' || acao == 'editar')"
          :background-color="isFormLoading || (acao == 'novo' || acao == 'editar') ? '#f2f2f2' : null"
        ></v-autocomplete>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :acao="acao"
      :id="form.identificadorpreparacao"
      :novo="novaPreparacao"
      :editar="editarPreparacao"
      :excluir="excluirPreparacao"
      :cancelar="cancelarPreparacao"
      :submit="onSubmit">
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaPreparacao">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
      <v-card>
        <v-card-text >
          <v-row no-gutters>
            <v-col lg="7">
              <v-text-field label="Código da Preparação" v-model="form.identificadorpreparacao" outlined disabled background-color="#f2f2f2"></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col lg="7">
              <Validate :v="$v.form.descricaopreparacao">
                <v-text-field
                  slot-scope="{ props }"
                  v-bind="props"
                  label="Descrição da Preparação*"
                  v-model="form.descricaopreparacao"
                  :disabled="isFormDisabled"
                  :background-color="isFormDisabled ? '#f2f2f2' : null"
                  outlined>
                </v-text-field>
              </Validate>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col lg="7">
              <Validate :v="$v.form.identificadorgrupopreparacao">
                <v-autocomplete
                  slot-scope="{ props }"
                  v-bind="props"
                  v-model="form.identificadorgrupopreparacao"
                  :items="gruposPreparacaoOptions"
                  outlined
                  label="Grupo de Preparação*"
                  :no-data-text="grupoLoading ? 'Carregando dados, aguarde...' : grupoSearch ? `Nenhuma opção encontrada com '${grupoSearch}'` : 'Nenhuma opção carregada'"
                  :search-input.sync="grupoSearch"
                  :disabled="isFormDisabled"
                  :background-color="isFormDisabled ? '#f2f2f2' : null"
                  :loading="grupoLoading && (acao == 'novo' || acao == 'editar')"
                  loader-height="3"
                  @focus="loadGruposOptions"
                ></v-autocomplete>
              </Validate>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col lg="7">
              <Validate :v="$v.form.indicainvernoverao">
                <v-radio-group v-model="form.indicainvernoverao" row  slot-scope="{ props }" v-bind="props" >
                  <template v-slot:label>
                    <div>Estação*</div>
                  </template>
                  <v-radio value="V" label="Verão" :disabled="isFormDisabled" :background-color="isFormDisabled ? '#f2f2f2' : null"></v-radio>
                  <v-radio value="I" label="Inverno" :disabled="isFormDisabled" :background-color="isFormDisabled ? '#f2f2f2' : null"></v-radio>
                  <v-radio value="A" label="Ambos" :disabled="isFormDisabled" :background-color="isFormDisabled ? '#f2f2f2' : null"></v-radio>
                </v-radio-group>
              </Validate>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const PreparacaoRepository = RepositoryFactory.get("preparacao");
const GrupoPreparacaoRepository = RepositoryFactory.get("grupoPreparacao");

const setFormInicial = () => ({
  identificadorpreparacao: '',
  descricaopreparacao: '',
  identificadorgrupopreparacao: '',
  indicainvernoverao: ''
});

export default {
  name: 'Preparacao',
  data() {
    return {
      acao: '',
      form: setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      buscarSelect: 'descricaopreparacao',
      buscaOptions: [
        { value: 'identificadorpreparacao', text: 'Código' },
        { value: 'descricaopreparacao', text: 'Descrição' },
      ],
      formUltimo: {},
      loading: false,
      gruposPreparacaoOptions: [],
      searchSelected: '',
      buscaPreparacoes: [],
      search: '',
      buscarLoading: false,
      filtrarBusca: this.filtrarBuscaDescricao,
      grupoLoading: false,
      grupoSearch: '',
      grupoFoiCompletamenteCarregado: false,
    };
  },

  validations: {
    form: {
      descricaopreparacao: { required, maxLength: maxLength(100) },
      identificadorgrupopreparacao: { required },
      indicainvernoverao: { required }
    }
  },

  created: function() {
    this.$Progress.finish();
  },

  computed: {
    isFormDisabled() {
      return this.acao == '' || this.acao == 'excluir' || this.isFormLoading
    },
    isFormLoading() {
      return this.loading
    },
  },

  methods: {
    tabelaPreparacao() {
      this.$root.$router.push({
        name: 'tabelas',
        params: {
          titulo: 'Preparação / Listar',
          rota_api: 'merenda/preparacao/tabela',
          headers: [{ text: 'Identificador', value: 'identificadorpreparacao', sortable: false },
						          { text: 'Grupo de Preparação', value: 'descricaogrupopreparacao', sortable: false },
                      { text: 'Descrição', value: 'descricaopreparacao', sortable: false },
                      { text: 'Estação', value: 'indicainvernoverao', sortable: false },],
        },
      });
    },
    novaPreparacao() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.$v.$reset();
    },
    editarPreparacao() {
      this.acao = 'editar';
    },
    cancelarPreparacao() {
      if (this.acao == 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
      this.loading = false;
    },
    async excluirPreparacao() {
      this.acao = 'excluir';

      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir esta preparação?',
        type: 'warning',
        buttons: [
          { text: 'Sim, excluir', color: 'red', response: true },
          { text: 'Não, cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          this.loading = true;
          const { data } = await PreparacaoRepository.deletarPreparacao(this.form.identificadorpreparacao);

          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
          this.buscaPreparacoes = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }

      this.acao = '';
      this.loading = false;
    },

    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) return;
      this.loading = true;
      this.msgArrayError = []

      try {
        const { data } = await PreparacaoRepository[this.acao === 'novo' ? 'criarPreparacao' : 'editarPreparacao'](this.form);

        this.acao = '';
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...data.results };
        this.formUltimo = { ...this.form };
        this.$v.$reset();
        this.buscaPreparacoes = [];
      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.loading = false;
      }
    },

    filtrarBuscaCodigo(item, queryText, itemText) {
      return item.identificadorpreparacao == queryText
    },

    filtrarBuscaDescricao(item, queryText, itemText) {
      return itemText.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    },

    encontrado(dados) {
      this.form = setFormInicial();
      let dado = this.buscaPreparacoes.find(e => e.identificadorpreparacao == dados);
      this.form = {
        identificadorpreparacao: dado.identificadorpreparacao,
        descricaopreparacao: dado.descricaopreparacao,
        identificadorgrupopreparacao: dado.identificadorgrupopreparacao,
        indicainvernoverao: dado.indicainvernoverao
      };
      this.formUltimo = { ...this.form };
      if (!this.grupoFoiCompletamenteCarregado) {
        this.gruposPreparacaoOptions = [{
          value: dado.identificadorgrupopreparacao,
          text: dado.descricaogrupopreparacao
        }]
      }
      this.$nextTick(() => {
        this.searchSelected = null;
        this.search = '';
      });
      this.acao = '';
    },

    onChangeBuscaOptions(option) {
      if (option == 'identificadorpreparacao') this.filtrarBusca = this.filtrarBuscaCodigo
      else if (option == 'descricaopreparacao') this.filtrarBusca = this.filtrarBuscaDescricao
    },

    async loadGruposOptions() {
      if (this.gruposPreparacaoOptions.length  && this.grupoFoiCompletamenteCarregado) {
        return
      }
      this.grupoLoading = true;
      this.gruposPreparacaoOptions = [];
      const { data } = await GrupoPreparacaoRepository.buscarGrupoPreparacao();
      for (const key of data.results) {
        this.gruposPreparacaoOptions.push({value: key.identificadorgrupopreparacao , text: key.descricaogrupopreparacao })
      }
      this.grupoLoading = false;
      this.grupoFoiCompletamenteCarregado = true;
    },

    async buscar() {
      if (this.buscaPreparacoes.length || this.buscarLoading) return
      this.buscarLoading = true
      const { data } = await PreparacaoRepository.buscarPreparacao();
      for (const key of data.results) {
        this.buscaPreparacoes.push(key)
      }
      this.buscarLoading = false
    }

  },
};
</script>

<style scoped>
.select-ajax { width: 60%; }
@media only screen and (max-width: 700px) {
  .select-ajax {
      width: 100%;
  }
}
</style>
